import { ARTICLES } from '../lib/articles'
import Seo from './Seo'
import { L, useLocale, useT } from '../i18n/locale.jsx'
import { getSeo } from '../i18n/seo'

export default function ArticleIndex() {
  const locale = useLocale()
  const t = useT().articles
  const seo = getSeo(locale).articles
  // Arată doar articolele pieței locale-ului curent (ro→ro, de→ch, en→en).
  const localeMarket = { en: 'en', ro: 'ro', de: 'ch' }
  const visible = ARTICLES.filter((a) => (a.market || 'en') === (localeMarket[locale] || 'en'))
  return (
    <section data-theme="light" className="px-5 pb-28 pt-32 text-ink md:px-10 md:pb-40 md:pt-40">
      <Seo title={seo.title} description={seo.description} />
      <div className="mx-auto max-w-site">
        <L to="/" className="mb-10 inline-block font-mono text-[12px] uppercase tracking-[0.1em] text-ink-muted transition-colors hover:text-honey-deep">{t.back}</L>
        <p className="eyebrow mb-8">{t.eyebrow} ✦</p>
        <h1 className="font-sans font-semibold tracking-tight mb-12 max-w-[24ch] text-4xl leading-[1.1] md:text-6xl">{t.heading}</h1>
        {visible.length === 0 ? (
          <p className="text-lg text-ink-soft">{t.soon}</p>
        ) : (
          <ul className="border-t border-ink/15">
            {visible.map((a) => (
              <li key={a.slug} className="border-b border-ink/15">
                <L to={`/articole/${a.slug}`} className="group flex flex-col gap-2 py-8 transition-colors hover:bg-ink/[0.03] md:flex-row md:items-baseline md:justify-between md:gap-8">
                  <span className="font-sans font-semibold tracking-tight max-w-[44ch] text-2xl leading-snug text-ink transition-colors group-hover:text-honey-deep md:text-[28px]">{a.title}</span>
                  <span className="shrink-0 font-mono text-[11px] uppercase tracking-[0.1em] text-ink-muted">{a.industry}{a.market ? ` · ${a.market.toUpperCase()}` : ''} · {a.date}</span>
                </L>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  )
}
